import React, { Component } from 'react'
import { ReadingProgressBarDefault } from './reading-progress-bar-default/reading-progress-bar-default'
import { ReadingProgressBarMessage } from './reading-progress-bar-message/reading-progress-bar-message'

import './reading-progress-bar.styl'

type Props = {
  finishedBooksCount: number | null | undefined
  promisedBooksCount: number | null | undefined
}

export class ReadingProgressBar extends Component<Props> {
  render(): JSX.Element {
    const { finishedBooksCount, promisedBooksCount } = this.props

    return (
      <div>
        {(promisedBooksCount && (
          <ReadingProgressBarDefault
            finishedBooksCount={finishedBooksCount}
            promisedBooksCount={promisedBooksCount}
          />
        )) ||
          null}
        <div className="reading-progress-bar__message">
          <ReadingProgressBarMessage
            finishedBooksCount={finishedBooksCount}
            promisedBooksCount={promisedBooksCount}
          />
        </div>
      </div>
    )
  }
}
